import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
// import { toColorString } from 'polished';
// import theme from '../../config/theme';

import format from 'date-fns/format';

// text-shadow: 0px 0px 0 ${props => props.theme.colors.warm.dark},
// 2px 0px 0 ${props => props.theme.colors.cool.dark},
// 0px 2px 0 ${props => props.theme.colors.cool.dark},
// 2px 2px 0 ${props => props.theme.colors.cool.dark};

const Wrapper = styled.div`
  padding-top: 2rem;
  padding-bottom: 2rem;
  img,
  tr,
  .gatsby-resp-iframe-wrapper {
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.7);
    margin-bottom: 1rem;
  }

  .gatsby-highlight {
    margin-bottom: 2rem;
  }
  ul {
    list-style: none;
    margin-left: 0;
    padding-left: 0em;
    text-indent: -1.8rem;
  }
  p,
  li {
    list-style: none;
    letter-spacing: -0.003em;
    --baseline-multiplier: 0.179;
    --x-height-multiplier: 0.35;
    font-size: 1.35rem;
    line-height: 1.6;
    code {
      padding: 0.2rem 0.5rem;
      margin: 0.5rem 0;
    }
  }
  a {
    color: ${props => props.theme.set.light.p};
    border-bottom: 3px solid ${props => props.theme.set.light.a};
    text-shadow: ${props => props.theme.set.light.shadow.text.small};
    font-weight: 600;
    transition: ${props => props.theme.transitions.main.transition};
    &:focus,
    &:hover {
      color: ${props => props.theme.set.light.h1};
      background-color: ${props => props.theme.set.light.highlight};
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    a {
      color: ${props => props.theme.set.light.a};
      box-shadow: rgba(black, 0);
      border-bottom: 0;
      &:hover,
      &:focus {
        color: ${props => props.theme.set.light.highlight};
        background: none;
      }
    }
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  Text,
  li,
  ul {
    max-width: 55rem;
    margin-left: auto;
    margin-right: auto;
    padding: 0 2rem;
  }

  .imgWrapDiv {
    overflow: hidden;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.7);
  }


  table {
    margin-top: 1.5rem;
    max-width: 1920px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.7);
}

  img,
  .gatsby-remark-image,
  .gatsby-resp-image-wrapper,
  gatsby-remark-image {
  }

  .gatsby-resp-image-wrapper {
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.7);

    margin-bottom: 1rem;
    transition: ${props => props.theme.transitions.boom};
    @media only screen and (orientation: portrait) and (max-device-aspect-ratio: 1/1) {
        left: -25%;
        right: 25%;
        width: 175%;
        position: relative;

      :focus,
      :hover {
        width: 100%;
        left: 0;
        right: 0;
      }

    }
    @media (min-width: 1921px) {
      width: 100%;
    }
  }
  /*and (max-height: max-device-width) 
   and (max-width: max-height)
  */
  tr {
    border-radius: ${props => props.theme.borderRadius.round};
  }
  td,
  th {
    text-align: center;
    border-radius: ${props => props.theme.borderRadius.round};
  }
  table {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    background-color: transparent;
  }
  h1 {
    margin-top: 2rem;
    margin-bottom: 0.25rem;
    /* 
    margin-left: -0.06125rem; 
    */
    /*
    margin-left: -0.030625rem; 
    */

    color: ${props => props.theme.set.light.h1};
    text-shadow: ${props => props.theme.set.light.shadow._3dThin};
  }
  h3 {
    position: relative;
    margin-top: 0.5rem;
    margin-bottom: 0.25rem;
  }

  h6 {
    font-size: 1.5rem;
    margin-bottom: -0.5rem;
    margin-top: -1.5rem;
    color: ${props => props.theme.set.light.h1};
    text-shadow: ${props => props.theme.set.light.shadow._3dThin};
  }
  .subH {
    a {
      bottom-margin: -40rem;
      color: ${props => props.theme.set.light.a};
      box-shadow: rgba(black, 0);
      border-bottom: 0;
      &:hover,
      &:focus {
        color: ${props => props.theme.set.light.highlight};
        background: none;
      }
    }
  }
  .gifDiv {
    width: 100%;
    img {
      width: 100%;
    }
    @media (min-width: 1000px) {
      margin-bottom: 2.5rem;
    }
  }
  .gatsby-highlight {
    div {
      max-width: 200px;
      padding-top: 2rem;
      padding-bottom: 2rem;
    }
  }
  code {
    position: relative;
    margin-bottom: 5rem;
  }
  .language-javascript {
      margin: 1rem auto;
      max-width: 1920px;
      background-color: ${props => props.theme.colors.pure.ink};
      font-size: 1.1225rem;
      font-size: 1rem;
      font-family: 'Source Code Pro', 'Courier New', Courier, monospace;
      code {
        
      }
  }
  .language-text {
    font-family: 'Source Code Pro', 'Courier New', Courier, monospace;
    background-color: rgba(0,0,0,0);
    color: ${props => props.theme.set.light.p};
    code {       
    }
  }
  /*
  .media4x3 > iframe, div {   
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
    div {
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.7);
    }
    @media(min-width: 1174px) {
    div {      
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0);
      top-margin: 2rem;
    }
    iframe {
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.7);
    }
      max-width: 1172px;
      max-height: 880px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .media4x3 > .gatsby-resp-iframe-wrapper, div {   
    margin-top: 1.5rem;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;

    iframe {
      background-color: black;
    }
    @media(min-width: 1174px) {
      margin-top: 0.5rem;
      max-width: 1274px;
      max-height: 880px;
      width: 100%;
      height: 100%;
      top: -1.08rem;
      margin-bottom: 3rem;
    }
  }
  
   .media4x3 {
    margin-left: auto;
    margin-right: auto;

    @media(min-width: 1174px) {
      position: absolute;
      top: 1.65rem;
      left: 1rem;
    }
  }


  .media16x9 > iframe, div {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
    background-color: transparent;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0);

    div {
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.7);
    }
    @media(min-width: 1921px) {
    div {
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0);
      top-margin: 20rem;
    }
    iframe {
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.7);
    }
      max-width: 1920px;
      max-height: 1080px;
      margin-left: 3rem;
      margin-right: 3rem;
    }
  }

  .media16x9 > .gatsby-resp-iframe-wrapper, div {
    margin-top: 2.5rem;
    max-width: 100%;
    max-height: 100%;
    background-color: transparent;

    margin-left: auto;
    margin-right: auto;
    iframe {
      background-color: black;
    }
    @media(min-width: 1921px) {
      margin-top: 0.5rem;
      max-width: 1920px;
      max-height: 1080px;
      width: 100%;
      height: 100%;
      top: -1.08rem;
      margin-bottom: 3rem;
    }
  */
  .media4x3 {
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    background-color: black;
    @media (min-width: 1174px) {
      min-width: 1174px;
      min-height: 880px;
    }
  }

  .media4x3 > .gatsby-resp-iframe-wrapper,
  div {
    max-width: 1174px;
    max-height: 880px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1.5rem;
  }

  .media16x9 {
    background-color: black;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    top: -5rem;

    @media (min-width: 1921px) {
      min-width: 1920px;
      min-height: 1080px;
    }
  }

  .media16x9 > iframe,
  img {
    max-width: 1920px;
    margin-left: auto;
    margin-right: auto;
  }

  .fatLink {
    text-shadow: ${props => props.theme.set.light.shadow.pop};
  }

  .fatArrowLink {
    top:0.35rem;
    position:relative;
    font-size:2.75rem;
    font-weight:bolder;
  }

`;

const Content = ({ input }) => {
  // const updated = format(new Date(document.lastModified), 'MMM.DD.YYYY');
  if (typeof document !== 'undefined') {
    input = input.replace(/id="updated">(.*?)</gi, `id="updated">${format(new Date(document.lastModified), 'MMM.DD.YYYY')}<`);
  }
  return <Wrapper dangerouslySetInnerHTML={{ __html: input }} />;
}
export default Content;

Content.propTypes = {
  input: PropTypes.any.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Content.jsx